import Icon, { IconType } from 'components/Icon';
import { useTheme } from 'styled-components';
import * as S from './styles';

interface Props {
	icon: IconType;
	label: string;
	description: string;
	onSelect: () => void;
	disabledReason?: string;
	tooltipId?: string;
}

const ExportMenuItem = ({ icon, label, description, onSelect, disabledReason, tooltipId }: Props) => {
	const theme = useTheme();

	const disabled = !!disabledReason;

	const handleSelect = (e: Event) => {
		if (disabled) {
			e.preventDefault();
			return;
		}
		onSelect();
	};

	const tooltipProps =
		disabledReason && tooltipId
			? { 'data-tooltip-id': tooltipId, 'data-tooltip-content': disabledReason }
			: {};

	return (
		<S.Item onSelect={handleSelect} $disabled={disabled} data-testid={`export-menu-${label.toLowerCase().replace(/\s+/g, '-')}`} {...tooltipProps}>
			<S.IconWrap>
				<Icon type={icon} width={14} height={14} color={theme.gray[900]} />
			</S.IconWrap>
			<S.Text>
				<S.Label>{label}</S.Label>
				<S.Description>{description}</S.Description>
			</S.Text>
		</S.Item>
	);
};

export default ExportMenuItem;
